import useGetNewsTipAuthor from './useGetNewsTipAuthor'

export default useGetNewsTipAuthor
